var _user = (window['user']);
var _levels = (window['levels']);
//console.log(_user, _levels);

const getLevelValue = (level: string) => {
    return _levels[level.toUpperCase()] || 0;
}

function user() {
    return _user;
}
function isThisUser(email){
    return _user.email===email
}
function customer() {
    return _user.customer;
}
function checkLevel( level ) {
    return getLevelValue(_user.level) >= getLevelValue(level);
}
function isLevel( level ) {
    return getLevelValue(_user.level) === getLevelValue(level);
}

function isReadOnly(){
    return _user.is_read_only;
}

export {
    user,
    customer,
    checkLevel,
    isLevel,
    isReadOnly,
    isThisUser
};


// WEBPACK FOOTER //
// ./src/services/user.ts